// src/api/axiosConfig.js
import axios from 'axios';
import {authEvents} from "../event_handlers/AuthEventHandler";
import NewUUID from "../utils/randy/NewUUID";
import sessionTimeoutService from "../event_handlers/SessionTimeoutService";


const ApiClient = axios.create({
    baseURL:process.env.REACT_APP_API_URL,
    headers: {
        'Accept': 'application/json', // Ensure this aligns with what your API expects
        session_id: NewUUID(),
        // Any other default headers
    },
    withCredentials: true
});

// On every successful response, re-read session cookies and reschedule the session timer.
// For /api/auth/refresh: reschedule only after the response is in hand so the browser has
// applied Set-Cookie; use a short delay so we read the new SessionDeadline/SessionTimer.
ApiClient.interceptors.response.use(
    (response) => {
        const isRefresh = response.config?.url?.includes?.('/api/auth/refresh');
        if (isRefresh) {
            [100, 300, 600, 1000, 2000].forEach((ms) => {
                setTimeout(() => sessionTimeoutService.refreshSession(), ms);
            });
        } else {
            sessionTimeoutService.syncFromCookies();
        }
        return response;
    },
    (error) => {
    const errorData = error.response?.data;
    const errorUrl = error.config?.url || '';

    const isTokenError = errorData === 'token is invalid' ||
                        (typeof errorData === 'string' && errorData.toLowerCase().includes('token is invalid')) ||
                        (typeof errorData === 'object' && errorData?.error === 'token is invalid');

    // Don't trigger on MFA verification endpoints - those 401s are for invalid codes
    const isMfaEndpoint = errorUrl.includes('/mfa/verify');

    // Don't trigger on templates endpoint immediately after login (might be timing issue)
    const isTemplatesEndpoint = errorUrl.includes('/templates');
    const isRecentLogin = Date.now() - (window.__lastLoginTime || 0) < 5000;

    if (error.response && isTokenError && !isMfaEndpoint) {
        // If this is a templates call right after login, give it a moment - might be cookie timing
        if (isTemplatesEndpoint && isRecentLogin) {
            return Promise.reject(error);
        }

        authEvents.onTokenInvalid();
    }
    return Promise.reject(error);
    }
);

export default ApiClient;
